import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomTextField from '../../shared/CustomTextField';
import CustomDropDown from '../../shared/CustomDropDown';
import CustomPicker from '../../shared/CustomPicker';
import CustomUploadField from '../../shared/CustomUploadField';
import CustomRadioGroup from '../../shared/CustomRadioGroup';
import CustomGroupCheckbox from '../../shared/CustomGroupCheckbox';
import { leaderboardDurationTypes, leaderboardCategories, options, visibility } from '../constants';
import ScoreParametersDefault from './ScoreParametersDefault';
import CustomSwitch from '../../shared/CustomSwitch';

const useStyles = makeStyles(() => ({
  title: {
    margin: '16px 0px 0px 20px',
    fontFamily: 'Lato',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22.4px',
  },
  publishDateField: {
    width: '438px',
    height: '44px',
    padding: '12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    marginTop: '12px',
    marginBottom: '12px',
    border: '1px solid rgba(228, 231, 236, 1)',
    borderRadius: '8px',
    background: 'rgba(254, 254, 254, 1)',
    boxSizing: 'border-box',
  },
  detailsContainer: {
    padding: '15px 15px 0px 15px',
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    background: 'white', // Background color to ensure visibility
    padding: '10px',
    zIndex: 10, // Ensure it's above other elements
  },
}));
const LeaderboardInfo = ({ handleDataChange, data, handleDateChange, handleDeleteLogo, thumbnail, logoFilename }) => {
  const classes = useStyles();

  return (
    <>
      <Grid container direction="row" className={classes.detailsContainer}>
        <Grid item xs={6}>
          <Grid container direction="column">
            <Grid item>
              <CustomPopupText text="Leaderboard Name" required />
            </Grid>
            <Grid item>
              <CustomTextField
                name="name"
                rows={1}
                placeholder="Leaderboard Name"
                id="name_id"
                height="44px"
                width="482px"
                handleChange={handleDataChange}
                value={data.name}
                multiline={false}
              />
            </Grid>
            <Grid item>
              <CustomPopupText text="Category" required />
            </Grid>
            <Grid item>
              <CustomDropDown
                list={leaderboardCategories}
                height="44px"
                width="482px"
                marginBottom="20px"
                name="category"
                handleChange={handleDataChange}
                value="DEFAULT"
                disabled
              />
            </Grid>

            <Grid item>
              <CustomPopupText text="Start Date" required />
            </Grid>
            <Grid item>
              <CustomPicker
                type="default"
                data={data}
                handleDateChange={handleDateChange}
                customStyles={classes.publishDateField}
                name="startDate"
                disabled
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="column">
            <Grid item>
              <CustomPopupText text="Leaderboard Logo" required />
            </Grid>
            <Grid item>
              <CustomUploadField
                type="image"
                name="logo"
                value={thumbnail}
                handleChange={handleDataChange}
                handleDelete={handleDeleteLogo}
                fileName={logoFilename}
                customStyles={{ height: '44px', width: '482px' }}
                imgSrc={data?.logo}
              />
            </Grid>
            <Grid item>
              <CustomPopupText text="Duration Type" required />
            </Grid>
            <Grid item>
              <CustomDropDown
                list={leaderboardDurationTypes}
                height="44px"
                width="482px"
                marginBottom="20px"
                name="type"
                handleChange={handleDataChange}
                value={data.type}
              />
            </Grid>
            <Grid item>
              <CustomPopupText text="End Date" required />
            </Grid>
            <Grid item>
              <CustomPicker
                name="endDate"
                type="default"
                data={data}
                handleDateChange={handleDateChange}
                customStyles={classes.publishDateField}
                disabled
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.detailsContainer} style={{ height: '110px' }}>
        <Grid item xs={12}>
          <Grid container direction="column">
            <Grid item>
              <CustomPopupText text="Highlight Top Ranks" required />
            </Grid>
            <Grid item>
              <CustomTextField
                name="highlightTopScoreLogic"
                rows={4}
                placeholder="Highlight Top Ranks JSON"
                id="highlight_id"
                height="64px"
                handleChange={handleDataChange}
                value={data.highlightTopScoreLogic}
                width="100%"
                multiline
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.detailsContainer}>
        <Grid item xs={6}>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item>
              <CustomPopupText text="Leaderboard Status :" />
            </Grid>
            <Grid item>
              <CustomRadioGroup
                value={Number(data?.enabled)}
                handleChange={handleDataChange}
                name="enabled"
                options={options}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item>
              <CustomPopupText text="Leaderboard Visibility :" />
            </Grid>
            <Grid item>
              <CustomGroupCheckbox data={data} handleChange={handleDataChange} name="visibility" options={visibility} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
            <Grid item>
              <CustomPopupText text="Is Default Leaderboard :" />
            </Grid>
            <Grid item>
              <CustomSwitch name="isDefault" checked={data?.isDefault} handleChange={handleDataChange} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {data?.category === 'DEFAULT' && (
        <Grid container direction="column" className={classes.detailsContainer}>
          <Grid item xs={12}>
            <ScoreParametersDefault add data={data} handleChange={handleDataChange} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default LeaderboardInfo;
